import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import Logo from '../Logo/Logo'
import Modal from '../Modal/Modal'
import * as Router from '../../shared/router'

const FreeTrialPopup = ({ show, popupText, onHide }) => {
  return (
    <Modal
      show={show}
      onHideModal={onHide}
      isForceShow={true}
      modalSize="modal-md"
      useClose={true}
    >
      <div className="d-flex flex-column">
        <div className="mb-3">
          <Logo width={120} />
        </div>
        <div className="mb-3">
          <span className="text-16 font-weight-bold">
            Payment Method Required!
          </span>
        </div>
        <div className="">
          <p>{popupText}</p>
        </div>
        <div>
          <NavLink to={Router.paymentMethod} className="btn btn-darkprimary">
            <span>Go to payment methods</span>
          </NavLink>
        </div>
      </div>
    </Modal>
  )
}

FreeTrialPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  popupText: PropTypes.string.isRequired,
}

export default FreeTrialPopup
